import { retrieveItem } from '@flexera/lib.setting-storage';

export const getSavedFavorites = async (orgId: string) => {
	const retreivedFavorites = await retrieveItem({ key: 'favorite-menu', orgId });
	return retreivedFavorites;
};
